import { ProvidedPathVar, SidebarItem } from './sidebar-data';

export const getNavLinkPath = (
  menuItem: SidebarItem,
  providedPathVars: Record<ProvidedPathVar, string | undefined>
): string => {
  const { providedPathVar, path } = menuItem;
  if (!path) return '';
  switch (providedPathVar) {
    case 'TEAM_ID':
      if (!providedPathVars.TEAM_ID) return path;
      return path + providedPathVars.TEAM_ID;
    case 'USER_ID':
      if (!providedPathVars.USER_ID) return path;
      return path + providedPathVars.USER_ID;

    default:
      return path;
  }
};

export const isNavLinkDisabled = (
  providedPathVars: Record<ProvidedPathVar, string | undefined>,
  currentPathVar?: ProvidedPathVar
) => {
  if (currentPathVar && !providedPathVars[currentPathVar]) return true;
  return false;
};
